module.exports = __webpack_public_path__ + "img/icn_Address.c13b5dd0.svg";